"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

var _strings = require("../../../../constants/strings");

var _Footer = require("./Footer.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var itemsPerPage = _strings.pagination.itemsPerPage,
    items = _strings.pagination.items,
    pageOf = _strings.pagination.pageOf;

var Footer = function Footer(_ref) {
  var children = _ref.children,
      config = _ref.config,
      pageSize = _ref.pageSize,
      setPageSize = _ref.setPageSize,
      data = _ref.data,
      pageOptions = _ref.pageOptions,
      pageIndex = _ref.pageIndex,
      previousPage = _ref.previousPage,
      canPreviousPage = _ref.canPreviousPage,
      nextPage = _ref.nextPage,
      canNextPage = _ref.canNextPage;
  return children ? /*#__PURE__*/_react.default.createElement(_Footer.TableFooter, null, children) : /*#__PURE__*/_react.default.createElement(_Footer.TableFooter, null, /*#__PURE__*/_react.default.createElement(_Footer.PageSize, null, /*#__PURE__*/_react.default.createElement("div", null, itemsPerPage), /*#__PURE__*/_react.default.createElement(_Footer.StyledSelect, {
    isClearable: false,
    name: "datagrid-items-per-page",
    dataTestId: "datagrid-items-per-page",
    onChange: function onChange(e) {
      setPageSize(e.value);
    },
    options: config.pageSizes.map(function (perPage) {
      return {
        value: perPage,
        label: perPage
      };
    }),
    selectedOption: {
      value: pageSize,
      label: pageSize
    },
    hoistErrors: function hoistErrors() {},
    suppressErrorSection: true
  })), /*#__PURE__*/_react.default.createElement(_Footer.ItemCount, null, "".concat(data.length, " ").concat(items)), /*#__PURE__*/_react.default.createElement(_Footer.PaginationControls, null, /*#__PURE__*/_react.default.createElement(_Footer.PaginationSpacer, null, /*#__PURE__*/_react.default.createElement("div", null, pageOf(pageIndex + 1, pageOptions.length)), /*#__PURE__*/_react.default.createElement(_Footer.PaginationButtons, null, /*#__PURE__*/_react.default.createElement(_Footer.StyledIconBubbleButton, {
    colorTheme: "primaryGhost",
    iconName: "chevron-left",
    buttonHeight: "small",
    dataTestId: "datagrid-prev-page",
    onClick: function onClick() {
      return previousPage();
    },
    disabled: !canPreviousPage
  }), /*#__PURE__*/_react.default.createElement(_Footer.StyledIconBubbleButton, {
    colorTheme: "primaryGhost",
    iconName: "chevron-right",
    buttonHeight: "small",
    dataTestId: "datagrid-next-page",
    onClick: function onClick() {
      return nextPage();
    },
    disabled: !canNextPage
  })))));
};

Footer.propTypes = {
  canNextPage: _propTypes.default.bool.isRequired,
  canPreviousPage: _propTypes.default.bool.isRequired,

  /** An Objects that determines which areas of the grid to show and some pagination variables */
  config: _propTypes.default.shape({
    /** page size options - see the datagrid component and react-table for more details
     * and yes, ignoring lint on this thing because i am in a bit of a hurry.  todo: fix lint exclusion
     */
    pageSizes: _propTypes.default.array
  }).isRequired,
  data: _propTypes.default.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  children: _propTypes2.default.children,
  nextPage: _propTypes.default.func.isRequired,
  pageIndex: _propTypes.default.number.isRequired,
  pageOptions: _propTypes.default.array.isRequired,
  // eslint-disable-line react/forbid-prop-types
  pageSize: _propTypes.default.number.isRequired,
  previousPage: _propTypes.default.func.isRequired,
  setPageSize: _propTypes.default.func.isRequired
};
Footer.defaultProps = {
  children: undefined
};
var _default = Footer;
exports.default = _default;